import { startCase } from 'lodash';
import { useLocation } from 'react-router-dom';
import { DISPLAY_NAME_MAP } from '@brighterion/utils/constants';

export const useGetListDetailsFromLocation = () => {
    const location = useLocation();
    const pathDetails = location.pathname.split('/');
    const mainPageData = pathDetails[2];
    let mainSubType = pathDetails?.[3] || '';
    const pageSubtypeDetails = pathDetails?.[4] ? 'RevisionDetails' : '';
    const getListFullUrl = mainPageData?.replace('-', ' ');
    const mainPage = mainPageData?.replace('-', '');
    const urlDerivedName = startCase(getListFullUrl);
    const currentListName = DISPLAY_NAME_MAP[urlDerivedName] || urlDerivedName;
    const listArray = getListFullUrl?.split(' ') || [];
    const subList = listArray[0];
    const list = listArray[1];
    if (mainSubType === 'review-changes') {
        mainSubType = 'Review';
    }
    if (mainSubType === 'revision-history') {
        mainSubType = 'Revision';
    }
    if (pageSubtypeDetails) {
        mainSubType = '';
    }
    return { currentListName, list, subList, mainPage, mainSubType, pageSubtypeDetails };
};
